<template>
<v-expansion-panels
    style="margin-top: 15px;"
>
    
    <v-expansion-panel>
        <v-expansion-panel-header>How to get the RedChirp chat widget on your site: Pixel Code</v-expansion-panel-header>

        <v-expansion-panel-content>
            <p>To display the RedChirp widget on your site, you need to include the following code.  The code may be placed anywhere in the body of the page (that is, between the open and close body tags). The code must be placed on <em>every</em> page where you would like the widget to show.</p>
            <m-code-block>{{pixel_code}}</m-code-block>
            
            <b>Please note:</b> you won't see any obvious changes to the site after you complete the work above. RedChirp web chat will not go live until further action is taken inside the software. To check your work, just look at the console. You should see "redchirp: pixel script start" even before we have turned the webchat live. It's a helpful way to test your work right away.

            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    v-on:click="linkToWidgetPixelCode"
                >
                    Link to Instructions
                </v-btn>
            </v-card-actions>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header>How to get the RedChirp chat widget on your site: Google Tag Manager</v-expansion-panel-header>
        <v-expansion-panel-content>
            <p>If you prefer, you can also deploy the pixel code using Google Tag Manager (GTM).  To do so, you will need to deploy the container <code>GTM-TXPXJK2</code> to your site.</p>
            <p>Many website providers, including Wix, Squarespace, Shopify, etc. have a built in way to deploy a Google Tag Manager container.  For instructions, or to see if your provider has built in support for a Google Tag Manager deployment, just goole "Wix Google Tag Manager" (or whomever your webiste provider is) and follow the instructions.</p>
            <p>If you wish to deploy this container manually, place the following code as high in the <b>&lt;head&gt;</b> of each page as possible:</p>

            <m-code-block>&lt;!-- Google Tag Manager --&gt;<br/>
                &lt;script&gt;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':<br/>
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],<br/>
                j=d.createElement(s),dl=l!='dataLayer'?'&amp;l='+l:'';j.async=true;j.src=<br/>
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);<br/>
                })(window,document,'script','dataLayer','GTM-TXPXJK2');&lt;/script&gt;<br/>
                &lt;!-- End Google Tag Manager --&gt;<br/>
            </m-code-block>

            <p>Additionally, paste this code immediately after the opening <b>&lt;body&gt;</b> tag:</p>
            <m-code-block>
                &lt;!-- Google Tag Manager (noscript) --&gt;<br/>
                &lt;noscript&gt;&lt;iframe src=&quot;https://www.googletagmanager.com/ns.html?id=GTM-TXPXJK2&quot;<br/>
                height=&quot;0&quot; width=&quot;0&quot; style=&quot;display:none;visibility:hidden&quot;&gt;&lt;/iframe&gt;&lt;/noscript&gt;<br/>
                &lt;!-- End Google Tag Manager (noscript) --&gt;<br/>
            </m-code-block>

            <b>Please note:</b> you won't see any obvious changes to the site after you complete the work above. RedChirp web chat will not go live until further action is taken inside the software. To check your work, just look at the console. You should see "redchirp: pixel script start" even before we have turned the webchat live. It's a helpful way to test your work right away.

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    v-on:click="linkToWidgetGTM"
                >
                    Link to Instructions
                </v-btn>
            </v-card-actions>

        </v-expansion-panel-content>
    </v-expansion-panel>

    <!--
    <v-expansion-panel>
        <v-expansion-panel-header>How to control which inbox(es) the RedChirp chat widget uses</v-expansion-panel-header>
        
        <v-expansion-panel-content>
            <p>By default, the Inbox URL(s) will control which inboxes the widget presents a visitor to a particular page on your website.  If you prefer, you can control the {{inbox_label}} used by the chat widget using meta tags.  To have the chat widget use the current {{inbox_label}}, add the below meta tag to the <b>&lt;head&gt;</b> section of the page:</p>
    
            <m-code-block>
                <br/>
                &lt;meta name="redchirp-inbox-ids" content="{{meta_inbox_ids}}"&gt;
                <br/>
            </m-code-block>
        </v-expansion-panel-content>
    </v-expansion-panel>
    -->

</v-expansion-panels>
</template>

<script>
export default {
    props: {
        inboxes: {
            type: Array,
            default: function () { return []; },
        },
    },

    data() {
        return {
            pixel_code: ''
        }
    },

    mounted () {
        
        let organization_id = this.$rc.$state.organization_id;
        this.$rc.getOrganizationProfile(organization_id, 
            (profile, pixel_code) => {
                this.pixel_code = pixel_code;
            },
        );
    },

    methods: {
        linkToWidgetPixelCode() {
            window.open("/app/public/widget-pixel-code-instructions","_blank");
        },
        linkToWidgetGTM() {
            window.open("/app/public/widget-gtm-instructions","_blank");
        },
    },

    computed: {
        meta_inbox_ids() 
        {
            let ret = '';

            for ( let i = 0; i < this.inboxes.length; i++ )
            {
                if ( ret.length != 0 )
                    ret += '; ';
                
                ret += this.inboxes[i].organization_id + ':' + this.inboxes[i].inbox_id;
            }

            return ret;
        },

        inbox_label()
        {
            if ( this.inboxes.length <= 1 )
                return "inbox";

            return "inboxes";
        }
    },
}
</script>

<style lang="scss" scoped>

</style>